import React from 'react';

const MAX_VISIBLE = 99;

// Burbuja roja con el número de mensajes sin leer, sobre el botón del chat. Sin mensajes no
// pinta nada. Los estilos (.chat-unread-badge) viven en index.css junto a .btn-chat.
export default function ChatUnreadBadge({ count }) {
  if (!count || count < 1) {
    return null;
  }

  return (
    <span
      className="chat-unread-badge"
      data-testid="chat-unread-badge"
      role="status"
      aria-label={`${count} unread messages`}
    >
      {count > MAX_VISIBLE ? `${MAX_VISIBLE}+` : count}
    </span>
  );
}
